import { motion } from "framer-motion";
import { ORDER_ONLINE_URL, DELIVERY_URL } from "../lib/data";

export default function OrderCallout() {
    return (
        <section
            data-testid="order-callout"
            className="relative py-16 md:py-24 bg-[#FAF8F4]"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1] }}
                    className="bg-[#121212] text-[#FAF8F4] px-8 md:px-16 py-14 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 items-center"
                >
                    <div className="md:col-span-7">
                        <p className="text-xs uppercase tracking-[0.28em] font-semibold text-[#EB4A18] mb-4">
                            Skip the queue
                        </p>
                        <h2 className="font-display uppercase text-[clamp(2.4rem,5.5vw,4.5rem)] leading-[0.95]">
                            Hungry?{" "}
                            <span className="text-[#EB4A18]">
                                Order now.
                            </span>
                        </h2>
                        <p className="mt-5 text-[#C7C2B8] text-base md:text-lg leading-relaxed max-w-xl">
                            Click, Collect, and dig in — or get it delivered
                            via Uber Eats.
                        </p>
                    </div>
                    <div className="md:col-span-5 flex flex-col md:items-end gap-3">
                        <a
                            href={ORDER_ONLINE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="callout-order-online-btn"
                            className="inline-flex items-center justify-center gap-3 bg-[#EB4A18] hover:bg-[#FAF8F4] hover:text-[#121212] text-[#FAF8F4] px-9 py-5 text-sm uppercase tracking-[0.22em] font-bold transition-colors duration-300 w-full md:w-auto"
                        >
                            Order Pickup
                            <span aria-hidden="true">→</span>
                        </a>
                        <a
                            href={DELIVERY_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="callout-delivery-btn"
                            className="inline-flex items-center justify-center gap-3 bg-transparent border border-[#FAF8F4]/60 hover:bg-[#FAF8F4] hover:text-[#121212] text-[#FAF8F4] px-9 py-5 text-sm uppercase tracking-[0.22em] font-bold transition-colors duration-300 w-full md:w-auto"
                        >
                            Get Delivery
                            <span aria-hidden="true">→</span>
                        </a>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
